import React from 'react';
import styled from 'styled-components';

const BubbleTale = () => {
  return (
    <Container>
      <Section>
        <Triangle />
      </Section>
    </Container>
  );
};

export default BubbleTale;

const Container = styled.div`
  position: absolute;
  top: 10px;
`;

const Section = styled.div`
  position: relative;
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 40px solid #d9d9d9; /* 삼각형 색상 */
  position: absolute;
  top: 10px;
  right: 0;
`;
